"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormInput = _interopRequireDefault(require("../../../blocks/FormInput"));

var _StatusText = _interopRequireDefault(require("../../../elements/StatusText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const TextInput = props => {
  const error = props.error,
        icon = props.icon;
  const inputMods = [error ? 'error' : null, icon ? 'withIcon' : null];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FormInput.default, null, icon ? /*#__PURE__*/_react.default.createElement(_FormInput.default.Icon, {
    src: icon
  }) : null, /*#__PURE__*/_react.default.createElement(_FormInput.default.Input, _extends({}, props, {
    modifiers: inputMods
  }))), error ? /*#__PURE__*/_react.default.createElement(_StatusText.default, {
    modifiers: ['error']
  }, error) : null);
};

TextInput.propTypes = {
  onChange: _propTypes.default.func.isRequired,
  error: _propTypes.default.string,
  icon: _propTypes.default.string
};
TextInput.defaultProps = {
  error: '',
  icon: ''
};
var _default = TextInput;
exports.default = _default;